import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Field from "features/application/field/component";

import "features/application/email-confirmation/view.scss";

const EmailConfirmationView = ({
  errorCodes,
  userData,
  isEmailForgotten,
  forgetEmail,
  resendVerificationMessage,
  termsDescriptionReference,
  backToPreviousStep,
  sendApiRequest,
}) => (
  <Fragment>
    {userData.is_verified_email ? (
      <form
        className="form__content email-confirmation__content"
        noValidate
        onSubmit={sendApiRequest}
      >
        <h1 className="application__headline">Terms & Conditions</h1>
        <article className="email-confirmation__document">
          <p
            className="email-confirmation__description"
            ref={termsDescriptionReference}
          ></p>
        </article>
        <Field
          label="I agree to the Terms & Conditions"
          name="termsAndConditions"
          type="checkbox"
          shouldValidate={true}
          rule="checkbox"
          error="You must accept terms and conditions if you want to be a Parlor Member."
        />
        <div className="application__buttons">
          <button
            className="application__button"
            type="button"
            onClick={backToPreviousStep}
          >
            Back
          </button>
          <button className="application__button" type="submit">
            Submit
          </button>
        </div>
      </form>
    ) : isEmailForgotten ? (
      <form
        className="form__content email-confirmation__content"
        noValidate
        onSubmit={sendApiRequest}
      >
        <h1 className="application__headline">Change your e-mail address</h1>
        <Field
          label="E-mail address"
          name="email"
          type="email"
          maxLength={320}
          shouldValidate={true}
          rule="email"
          error="It doesn't look like a valid e-mail address."
          styles={{ maxWidth: "320px" }}
        />
        <div className="application__buttons email-confirmation__buttons">
          <button
            className="application__button"
            type="button"
            onClick={() => forgetEmail(false)}
          >
            Back
          </button>
          <button className="application__button" type="submit">
            Submit
          </button>
        </div>
      </form>
    ) : (
      <div className="form__content email-confirmation__content">
        <h1 className="application__headline">Confirm your e-mail address</h1>
        <p style={{ paddingTop: "20px" }}>
          <span className="email-confirmation__information">
            One more step. Please check your inbox and confirm your email
            address by clicking on the URL provided.{" "}
          </span>
          <button
            className="email-confirmation__button"
            type="button"
            onClick={() => resendVerificationMessage(userData.email)}
          >
            Resend message.
          </button>
        </p>
        <p className="email-confirmation__email">{userData.email}</p>
        <p>
          <span className="email-confirmation__information">
            It isn&apos;t a correct e-mail address?{" "}
          </span>
          <button
            className="email-confirmation__button"
            type="button"
            onClick={() => forgetEmail(true)}
          >
            Change e-mail address.
          </button>
        </p>
        {errorCodes.verificationMessage &&
          errorCodes.verificationMessage.toString().startsWith("4") && (
            <p className="authentication__information email-confirmation__error">
              Something went wrong. Please try again later.
            </p>
          )}
        <div className="application__buttons email-confirmation__buttons">
          <button
            className="application__button email-confirmation__back"
            type="button"
            onClick={backToPreviousStep}
          >
            Back
          </button>
        </div>
      </div>
    )}
  </Fragment>
);

EmailConfirmationView.propTypes = {
  errorCodes: PropTypes.object,
  userData: PropTypes.object,
  isEmailForgotten: PropTypes.bool,
  forgetEmail: PropTypes.func,
  resendVerificationMessage: PropTypes.func,
  termsDescriptionReference: PropTypes.object,
  backToPreviousStep: PropTypes.func,
  sendApiRequest: PropTypes.func,
};

export default EmailConfirmationView;
